import type { AuthContextProps } from 'react-oidc-context'
import { getHub } from './hub'

/*
  Ends the session now, so the server's cancel-on-disconnect doesn't wait on the navigation,
  then hands off to Keycloak. stop() arms a reload in case the page survives. signoutRedirect
  drops the stored user before its network calls, so that reload lands on login; removeUser
  here covers a failure before that point.
 */
export const signOut = (
  auth: Pick<AuthContextProps, 'signoutRedirect' | 'removeUser'>,
  onError: (err: unknown) => void
): Promise<void> => {
  getHub().stop().catch(onError)
  return auth.signoutRedirect().catch((err) => {
    onError(err)
    return auth.removeUser().catch(onError)
  })
}
